export const showAnnualReceiptBanner = function () {
    const currentDate = new Date();

    const value = dcLocalStorage.getValue('xAnnualReceiptBanner');
    if (value == null) {
        if (typeof userObj !== 'undefined' &&
            userObj.hasGreenDollars &&
            (currentDate.getMonth() < 3 || (currentDate.getMonth() === 3 && currentDate.getDate() <= 15))) {
            $('#annual-receipt-banner').show();
        }
    }
};

export const hideAnnualReceiptBanner = function () {
    const lastDayOfYear = new Date((new Date()).getFullYear(), 11, 31);
    const ttl = lastDayOfYear - (new Date()).getTime();
    dcLocalStorage.setValue('xAnnualReceiptBanner', 'true', ttl);
    $('#annual-receipt-banner').hide();
};
